"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../Icons");

var _Link = _interopRequireDefault(require("../Link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var hidePopUpFunctionTimer;

var NotificationListBox = function NotificationListBox(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      time = _ref.time,
      description = _ref.description,
      children = _ref.children,
      seen = _ref.seen,
      formattedTime = _ref.formattedTime,
      to = _ref.to,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$tooltipText = _ref.tooltipText,
      tooltipText = _ref$tooltipText === void 0 ? 'Mark notification as seen' : _ref$tooltipText,
      _ref$markRead = _ref.markRead,
      markRead = _ref$markRead === void 0 ? function () {} : _ref$markRead,
      className = _ref.className,
      otherProps = _ref.otherProps;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var markAsRead = function markAsRead() {
    setShow(false);
    hidePopUpFunctionTimer = setTimeout(function () {
      // after hide animation return the callback function
      markRead();
    }, 500);
  };

  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(hidePopUpFunctionTimer);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: className,
    show: show
  }, otherProps), /*#__PURE__*/_react.default.createElement(NotificationBox, {
    to: to,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(HeaderContainer, null, icon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(IconCircle, {
    seen: seen
  }, icon)), /*#__PURE__*/_react.default.createElement(HeaderContentContainer, null, /*#__PURE__*/_react.default.createElement(Title, null, title), /*#__PURE__*/_react.default.createElement(Description, null, description)), /*#__PURE__*/_react.default.createElement(TimeLeft, {
    title: formattedTime
  }, time)), /*#__PURE__*/_react.default.createElement(ContentContainer, null, children)), /*#__PURE__*/_react.default.createElement(MarkIconContainer, null, /*#__PURE__*/_react.default.createElement(MarkIcon, {
    onClick: markAsRead
  }, /*#__PURE__*/_react.default.createElement(TooltipContainer, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement("p", null, tooltipText)), seen ? /*#__PURE__*/_react.default.createElement(_Icons.IconActionUnRead, {
    size: 22,
    color: "white"
  }) : /*#__PURE__*/_react.default.createElement(_Icons.IconActionRead, {
    size: 22,
    color: "white"
  }))));
};

var TooltipContainer = _styledComponents.default.div.withConfig({
  displayName: "TooltipContainer"
})(["position:absolute;bottom:calc(100% + 1rem);padding:1.5rem;font-size:1.4rem;border-radius:0.5rem;right:0;cursor:default;background-color:#11141c;visibility:hidden;opacity:0;color:white;transition:all 0.2s ease;&::after{content:'';top:100%;right:0.2rem;width:0;height:0;border:0.7rem solid transparent;border-top-color:#11141c;transform:translate(-50%,0);position:absolute;}"]);

var TimeLeft = _styledComponents.default.div.withConfig({
  displayName: "TimeLeft"
})(["font-weight:500;font-size:1.4rem;text-align:right;margin-left:2rem;flex-shrink:0;color:#8990a3;"]);

var MarkIcon = _styledComponents.default.button.withConfig({
  displayName: "MarkIcon"
})(["border-radius:50%;width:3rem;height:3rem;padding:0.3rem;border:0;display:flex;align-items:center;justify-content:center;background-color:", ";transition:all 0.2s ease;cursor:pointer;& > svg{height:90%;width:90%;}&:hover{background-color:", ";& > ", "{visibility:visible;opacity:1;}}&:focus{outline:none;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.brand.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.lighter;
}, TooltipContainer);

var IconCircle = _styledComponents.default.div.withConfig({
  displayName: "IconCircle"
})(["border-radius:50%;padding:0.5rem;width:100%;height:100%;background-color:", ";& > svg{height:100%;width:100%;}"], function (_ref4) {
  var theme = _ref4.theme,
      seen = _ref4.seen;
  return seen ? '#6d6d6d' : theme.brand.primary;
});

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["display:flex;width:100%;word-break:break-word;max-width:100%;position:relative;font-family:", ";transition:all 500ms ease;max-height:100rem;margin-bottom:2rem;", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.font;
}, function (_ref6) {
  var show = _ref6.show;
  return !show && "\n    opacity: 0;\n    margin-bottom: 0;\n    max-height: 0;\n    padding: 0;\n    border-color: rgba(0,0,0,0);\n    border-width: 0;\n    border: none;\n  ";
});

var NotificationBox = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "NotificationBox"
})(["text-decoration:none;display:flex;flex-direction:column;flex:1 1 100%;overflow:hidden;background:white;border:0.05rem solid #ececec;border-radius:0.5rem;cursor:pointer;transition:all 0.2s ease;filter:drop-shadow(-0.4rem 0.4rem 1.2rem rgba(0,0,0,0.05));&:hover{border:0.1rem solid ", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.brand.primary;
});

var HeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "HeaderContainer"
})(["display:flex;padding:2rem;min-height:7.8rem;border-bottom:0.1rem solid #ececec;align-items:center;"]);

var HeaderContentContainer = _styledComponents.default.div.withConfig({
  displayName: "HeaderContentContainer"
})(["display:flex;flex-direction:column;justify-content:center;flex:1 1 100%;"]);

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "IconContainer"
})(["margin-right:2rem;height:3.8rem;width:3.8rem;flex:0 0 auto;"]);

var Title = _styledComponents.default.div.withConfig({
  displayName: "Title"
})(["font-style:normal;font-weight:500;font-size:1.6rem;color:#2d2d2d;margin-bottom:0.5rem;"]);

var Description = _styledComponents.default.div.withConfig({
  displayName: "Description"
})(["font-style:normal;font-weight:normal;line-height:1.3;font-size:1.4rem;color:#8990a3;"]);

var ContentContainer = _styledComponents.default.div.withConfig({
  displayName: "ContentContainer"
})(["padding:2rem;font-style:normal;font-size:1.6rem;line-height:1.4;color:#8990a3;"]);

var MarkIconContainer = _styledComponents.default.div.withConfig({
  displayName: "MarkIconContainer"
})(["margin-left:2rem;display:flex;overflow:visible;align-items:flex-start;justify-content:flex-end;"]);

NotificationListBox.propTypes = {
  /** Boolean if the notification has been seen already or not. */
  seen: _propTypes.bool.isRequired,

  /** String how long ago the notification happened */
  time: _propTypes.string.isRequired,

  /** String how long ago the notification happened */
  formattedTime: _propTypes.string.isRequired,

  /** Notification description */
  description: _propTypes.string.isRequired,

  /** Notification title */
  title: _propTypes.string.isRequired,

  /** tooltip text */
  tooltipText: _propTypes.string,

  /** To url where to go to when clicking on the notification */
  to: _propTypes.string,

  /** onClick function when clicked on the notification */
  onClick: _propTypes.func,

  /** Pass an icon as element to be displayed at the front of the bar. */
  icon: _propTypes.element,

  /** onClick function when clicked on the eye icon */
  markRead: _propTypes.func,

  /** Code to be displayed within the element. This is also what will be copied if copying is enabled. */
  children: _propTypes.node.isRequired,

  /** Extra classnames to pass to the element. */
  className: _propTypes.string,

  /** Extra props to pass to the element. */
  otherProps: _propTypes.object
};
var _default = NotificationListBox;
exports.default = _default;